// routes/_app.tags._index.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.tags._index')

export const handle = { name: 'tags-home', showAppNav: true }

export default dynamic(getClientModule, { ssr: false })
